export default __webpack_public_path__ + "static/media/WNLProto.06044ead.jpg";